import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { database } from "../firebase";
import { useDispatch, useSelector } from "react-redux";
import { renderTooltip } from "./ShowToolTip";
import { Popover } from 'antd';
import Placeholder from "../assets/images/Placeholder.png";
import { DotLoader } from "react-spinners";
import { css } from "@emotion/react";

function VideoList({ id }) {
  const [loading, setLoading] = useState(false);

  const { currentUser } = useSelector((state) => ({
    currentUser: state.profile.currentUser,
  }));
  const [accepted, setAccepted] = useState([]);
  function getUserData(uid) {
    return new Promise((resolve, reject) => {
      return database.ref("users/" + uid).once("value", (snap) => {
        resolve(snap.val());
      });
    });
  }

  function getCreditzData(credid) {
    return new Promise((resolve, reject) => {
      return database.ref("creditz/" + credid).once("value", (snap) => {
        resolve(snap.val());
      });
    });
  }
  let userValue = "";
  useEffect(() => {
    if (id === undefined) {
      userValue = currentUser.uid;
    } else {
      userValue = id;
    }
  }, [id]);

  async function AcceptedCreditz(dummystate) {
    const user = [];
    setLoading(true);
    await database.ref("users/" + userValue).once("value").then(async (snapshot) => {
      user.push(snapshot.val())
    }).then(() => {
      return database
        .ref(`/user-creditz/`)
        .once("value")
        .then(async (snapshot) => {
          const request = [];
          let us = [];
          snapshot.forEach((childSnapshot) => {
            request.push(Object.values(childSnapshot.val()))
            us = request.map(req => {
              return req.find(r => {
                return r.email === user[0].email;
              })
            }).filter((e) => e);
          });
          const pendingRequests = [];
          us.map((req) => {
            if (req.status === "Accepted ") {
              pendingRequests.push(req);
            }
          })
            .filter((e) => e);
          let newRes = await Promise.all(
            pendingRequests.map(async (user) => {
              const Data = await getUserData(user.uid);
              const Creddata = await getCreditzData(user.credid);
              return {
                ...user,
                user_details: Data,
                Creditz: Creddata,
              };
            })
          );
          let filterres = newRes
            .map((music) => {
              if (music.Creditz?.category == "Youtube Video") {
                return {
                  ...music,
                  Creditz: music.Creditz,
                  user_details: music.user_details,
                };
              }
            })
            .filter((e) => e);
          await database.ref('/removeCreditz/' + userValue).once("value")
            .then(async (snapshot) => {
              let remove = [];
              remove.push(snapshot.val())
              if (remove[0]) {
                const newfilterres = filterres.map((filter) => {
                  if (!(filter.credid in remove[0])) {
                    return filter
                  }
                }).filter((e) => e);
                setAccepted(newfilterres);
              }
              else {
                setAccepted(filterres)
              }

              setLoading(false);
            })

        });

    })



  }
  const override = css`
  display: block;
  margin: 0 auto;
  border-color: purple;
  color: purple;
  opacity: 0.5;
  `;
  let [color] = useState();


  const [sent, setSent] = useState([]);


  async function GetCreditz() {
    let userValue = ""
    if (id === undefined) {
      userValue = currentUser.uid

    }
    else {
      userValue = id

    }
    await database.ref('/creditz').orderByChild('uid').equalTo(userValue)
      .once("value")
      .then(async (snapshot) => {
        const creditz = [];

        snapshot.forEach((childSnapshot) => {
          creditz.push({ key: childSnapshot.key, data: childSnapshot.val() });
        });

        var filterres =
          creditz.map((music) => {
            if (music.data.category == "Youtube Video") {
              return {
                ...music,
                Creditz: music.Creditz,

              };
            }
          })
            .filter((e) => e);

        database.ref('/removeCreditz/' + userValue).once("value")
          .then(async (snapshot) => {
            let remove = [];
            remove.push(snapshot.val())
            if (remove[0]) {
              const newfilterres = filterres.map((filter) => {

                if (!(filter.key in remove[0])) {
                  return filter
                }


              }).filter((e) => e);
              setSent(newfilterres);
            }
            else {
              setSent(filterres)
            }

          })

      }

      )
  }


  useEffect(() => {
    AcceptedCreditz();
    GetCreditz();
  }, []);

  return (
    <>
      {loading == true ? <DotLoader color={color} css={override} size={100} color={"#7444C0"}
      /> :
        sent.length + accepted.length <= 0 && id == undefined ?
          <div className="card rounded-xl shadow-xs border-0" >
            <div className="card-body text-center">

              <div className="overflow-hidden rounded-xl ratio ratio-1x1 mx-auto" id='image'>
                <img src={Placeholder} alt="avatar" />
              </div>

              <br></br>

              <Link to={`/AddCreditz`} >
                <button className="btn btn-primary fw-medium rounded-pill px-4" style={{ marginLeft: '6xpx' }}>
                  Add First Creditz{" "}
                </button>
              </Link>

            </div>

          </div>


          :
          accepted &&
          accepted.map((music, index) => (
            <div className="col" key={index}>
              {/* <Example /> */}

              <div className="card rounded-xl shadow-xs border-0" >
                <div className="card-body text-center">
                  <Popover content={renderTooltip(music.Creditz.albumImage, music.Creditz.username, music.Creditz.publishedAt)} placement="right" >
                    <div className="overflow-hidden rounded-xl ratio ratio-1x1 mx-auto" id='image'>
                      <img src={music.Creditz.albumImage} alt="avatar" />
                    </div>
                  </Popover>

                  <div className="fs-14 fw-semibold mt-3 mb-1">
                    {music.Creditz.trackname}
                  </div>
                  <div className="fs-12 text-muted mb-0">by {music.Creditz.artistname}</div>
                  <div className="pt-2 pb-3">
                    <span className="badge rounded-pill fw-medium bg-blue px-3 py-2 me-1">
                    <div className='fs-10'> {music.role} </div>
                    </span>

                  </div>
                  <Link to={`/viewcreditz/${music.credid}`} style={{marginRight:'5px'}} >
                    <button className="btn btn-primary fw-medium rounded-pill px-4" >
                   <div className='fs-10'>   View </div> 
                    </button>
                  </Link>

                </div>

              </div>

            </div>


          ))}

      {sent &&
        sent.map((music, index) => (
          <div className="col" key={index}>
            <div className="card rounded-xl shadow-xs border-0">
              <div className="card-body text-center">
                <Popover content={renderTooltip(music.data.albumImage, music.data.username, music.data.publishedAt)} placement="right" >
                  <div className="overflow-hidden rounded-xl ratio ratio-1x1 mx-auto">
                    <img src={music.data.albumImage} alt="avatar" />
                  </div>
                </Popover>

                <h5 className="fs-14 fw-semibold mt-3 mb-1">
                  {music.data.trackname}
                </h5>
                <p className="fs-12 text-muted mb-0">by {music.data.artistname}</p>
                <div className="pt-2 pb-3">
                <span className="badge rounded-pill fw-medium bg-blue px-3 py-2 me-1">
                    <div className='fs-10'> {music.data.role} </div>
                    </span>
                </div>
                <Link to={`/viewcreditz/${music.key}`} style={{marginRight:'5px'}} >
                    <button className="btn btn-primary fw-medium rounded-pill px-4" >
                   <div className='fs-10'>   View </div> 
                    </button>
                  </Link>

              </div>

            </div>

          </div>
        ))}
    </>
  );
}
export default VideoList;
